<div class="fixed-skill">
    <ul>
        <li>
            <label>My Expertise</label>
        </li>
        <li>
            <span>
                <img src="assets/img/figma.svg" title="" alt="">
            </span>
        </li>
        <li>
            <span>
                <img src="assets/img/angular-icon.svg" title="" alt="">
            </span>
        </li>
        <li>
            <span>
                <img src="assets/img/NET_Core.svg" title="" alt="">
            </span>
        </li>
        <li>
            <span>
                <img src="assets/img/css_3.svg" title="" alt="">
            </span>
        </li>
    </ul>
</div>
<div class="container">
    <div class="row align-items-end">
        <div class="col-lg-7">
            <div class="hs-text-box">
                <h1>I'm DONART</h1>
                <h2>I'm a <span class="typed-element"></span></h2>
                <div class="btn-bar">
                    <a class="px-btn light" href="#contactus"><span>Get in touch</span> <i class="bi-arrow-right"></i>
                    </a>
                </div>
                <div class="review-box">
                    <div class="r-box">
                        <h3>10<span>+</span></h3>
                        <label>Big Projects</label>
                    </div>
                    <div class="r-box">
                        <h3>7<span>+</span></h3>
                        <label>Years Experience</label>
                    </div>
                    <div class="r-box">
                        <h3>99<span>+</span></h3>
                        <label>Service Connections</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5">
            <div class="hs-banner">
                <img src="assets/img/Donart-Final.png" title="Donart Pllashniku" alt="DP">
            </div>
        </div>
    </div>
</div>